import React, { createContext, useContext, useState, ReactNode } from "react";

type WorkspaceThreadsContextType = {
  activeThreadId: string | null;
  setActiveThreadId: (id: string | null) => void;
  openWorkspaceId: string | null;
  setOpenWorkspaceId: (id: string | null) => void;
  toggleWorkspaceDrawer: (workspaceId: string) => void;
};

const WorkspaceThreadsContext = createContext<WorkspaceThreadsContextType>({
  activeThreadId: null,
  setActiveThreadId: () => {},
  openWorkspaceId: null,
  setOpenWorkspaceId: () => {},
  toggleWorkspaceDrawer: () => {},
});

export const WorkspaceThreadsProvider = ({ children }: { children: ReactNode }) => {
  const [activeThreadId, setActiveThreadId] = useState<string | null>(null);
  const [openWorkspaceId, setOpenWorkspaceId] = useState<string | null>(null);

  const toggleWorkspaceDrawer = (workspaceId: string) => {
    if (openWorkspaceId === workspaceId) {
      setOpenWorkspaceId(null);
    } else {
      setOpenWorkspaceId(workspaceId);
    }
  };

  return (
    <WorkspaceThreadsContext.Provider
      value={{
        activeThreadId,
        setActiveThreadId,
        openWorkspaceId,
        setOpenWorkspaceId,
        toggleWorkspaceDrawer,
      }}>
      {children}
    </WorkspaceThreadsContext.Provider>
  );
};

export const useWorkspaceThreads = () => {
  const context = useContext(WorkspaceThreadsContext);
  if (!context) {
    throw new Error("useWorkspaceThreads must be used within a WorkspaceThreadsProvider");
  }
  return context;
};
